import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#0597A3"
      d="M108.566 42.055a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M114.624 61.11a1.5 1.5 0 0 1 0 2.122l-9.994 9.994a1.501 1.501 0 0 1-2.122-2.122l9.994-9.994a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M102.508 61.11a1.5 1.5 0 0 1 2.122 0l9.994 9.994a1.501 1.501 0 0 1-2.122 2.121l-9.994-9.993a1.5 1.5 0 0 1 0-2.122"
      clipRule="evenodd"
    />
    <path
      fill="#0597A3"
      d="M38.102 75.906a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M9.319 57.022a1.5 1.5 0 0 1 1.5 1.5v14.134a1.5 1.5 0 0 1-3 0V58.52a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M.753 65.589a1.5 1.5 0 0 1 1.5-1.5h14.133a1.5 1.5 0 1 1 0 3H2.253a1.5 1.5 0 0 1-1.5-1.5M34.602 4.985a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#001A43"
      fillRule="evenodd"
      d="M1.642 39.555a2.59 2.59 0 0 1 2.592-2.591h14.379a2.591 2.591 0 1 1 0 5.183H4.234a2.59 2.59 0 0 1-2.592-2.592M50.585 56.502a2.59 2.59 0 0 1 3.05 2.032l1.161 5.801a10.4 10.4 0 0 0 10.196 8.366h1.416a2.591 2.591 0 1 1 0 5.183h-1.416A15.585 15.585 0 0 1 49.714 65.35v-.002l-1.161-5.797a2.59 2.59 0 0 1 2.032-3.05"
      clipRule="evenodd"
    />
    <path
      fill="#0597A3"
      d="M42.432 20.067h45.473a8.66 8.66 0 0 1 8.661 8.661v21.654a8.66 8.66 0 0 1-8.661 8.661H42.432a4.33 4.33 0 0 1-4.331-4.33V24.396a4.33 4.33 0 0 1 4.33-4.33"
    />
    <path
      fill="#00D8D8"
      d="M69.4 96.235c.754 5.274 5.639 8.939 10.913 8.185s8.939-5.639 8.185-10.913l-4.924-34.464H64.086zM22.944 26.564h15.158v25.984H22.944a4.33 4.33 0 0 1-4.331-4.331V30.894a4.33 4.33 0 0 1 4.33-4.33"
    />
    <path
      fill="#001A43"
      fillRule="evenodd"
      d="M61.836 33.06a2.25 2.25 0 0 1 2.25-2.25h12.992a2.25 2.25 0 1 1 0 4.5H64.086a2.25 2.25 0 0 1-2.25-2.25M61.836 46.052a2.25 2.25 0 0 1 2.25-2.25h12.992a2.25 2.25 0 1 1 0 4.5H64.086a2.25 2.25 0 0 1-2.25-2.25"
      clipRule="evenodd"
    />
  </svg>
);
const SvgEnrichedIconDrillInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconDrillInverted);
export default Memo;
